<template>
  <div>
    <form id="memoriesForm">
      <TabPanel>
        <app-button-create
          class="border-blue mb-4"
          color="blue"
          type="button"
          @click="showMemoryItemForm()"
        >
          <span class="text-blue font-bold text-lg">経費</span>
          <span class="text-blue font-bold text-sm">を</span>
          <span class="text-blue font-bold text-lg">新規追加</span>
        </app-button-create>
        <div class="flex flex-row border-b border-blue justify-between">
          <div class="mb-2 ml-3">
            <span class="text-blue font-bold text-lg">総支出</span>
          </div>
          <div class="mb-2 mr-3">
            <span class="text-blue font-bold text-lg">
              {{ calcTotalAmount(currentPoliticalAction.memory.expenses) }}
            </span>
          </div>
        </div>
        <div v-if="isShowingMemoryItem">
          <div
            v-for="(item, index) in currentPoliticalAction.memory.expenses"
            :key="'memory-form-expenses-' + index"
            ref="component"
          >
            <MemoryFormItem
              v-if="isShowingMemoryItem"
              :item="item"
              :index="index + 1"
              :length="currentPoliticalAction.memory.expenses.length"
              @show="showMemoryItemForm(item)"
              @remove="removeMemoryFormItem(item, index)"
            />
          </div>
        </div>
      </TabPanel>
      <TabPanel class="mr-5">
        <AppOfficeMessage color="blue" type="memory"></AppOfficeMessage>
      </TabPanel>
    </form>
    <MemoryFormDialog v-if="isChildOpen" />
  </div>
</template>

<script>
import AppButtonCreate from '@/components/ui/AppButtonCreate'
import MemoryFormItem from '@/components/layout/memoryToda/MemoryFormItem'
import MemoryFormDialog from '@/components/layout/memoryToda/MemoryFormDialog'
import AppOfficeMessage from '@/components/ui/uiToda/AppOfficeMessageToda'
import { TabPanel } from '@headlessui/vue'
import { useDialog } from '@/services/useDialog'
import { useMemoryItemForm } from '@/services/politicalActionToda/useMemoryItemForm'
import { useMemoryReject } from '@/services/politicalActionToda/useMemoryReject'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'

export default {
  name: 'MemoryForm_TODA',

  components: {
    TabPanel,
    AppButtonCreate,
    MemoryFormItem,
    MemoryFormDialog,
    AppOfficeMessage,
  },

  setup() {
    const { currentPoliticalAction } = usePoliticalActions()
    const { isShowingMemoryItem } = useMemoryItemForm()
    const { rejectHeaders, rejectedAttrs } = useMemoryReject()

    const calcTotalAmount = expenses => {
      const total = expenses.reduce((total, expense) => {
        const amount = expense?.receipt?.expenseAmount ?? 0
        const numerator = expense?.receipt?.numerator ?? 0
        const denominator = expense?.receipt?.denominator ?? 0
        const partialAmount = expense?.receipt?.partialAmount ?? 0
        if (amount === 0) {
          return total
        } else if (expense?.receipt?.isPartial && partialAmount !== 0) {
          return total + partialAmount
        } else if (
          expense?.receipt?.isDistributed &&
          numerator !== 0 &&
          denominator !== 0
        ) {
          return total + prorate(amount, numerator, denominator)
        } else {
          return total + amount
        }
      }, 0)
      return `${total.toLocaleString()}円`
    }

    /**
     * 按分する
     *
     * @param {number} amount
     * @param {number} numerator
     * @param {number} denominator
     * @returns number
     */
    const prorate = (amount, numerator, denominator) => {
      return Math.floor((numerator * amount) / denominator)
    }

    const showMemoryItemForm = item => {
      const { initMemoryItemForm, setMemoryItemForm } = useMemoryItemForm()
      const { openChildDialog } = useDialog()
      const isNewItem = item === null

      if (isNewItem) {
        initMemoryItemForm()
        openChildDialog()
      } else {
        // 既存のデータ読み込み
        setMemoryItemForm(item)
        openChildDialog()
      }
    }

    const removeMemoryFormItem = (item, index) => {
      // rejectHeadersから削除した記録簿と紐づく差し戻し用の配列削除
      rejectHeaders.splice(index, 1)

      // rejectHeadersに削除した記録簿よりもindexが高い記録簿が存在する場合attrの語尾の数値を−１する。
      for (let i = index; i < rejectHeaders.length; i++) {
        rejectHeaders[i].forEach(rejectHeader => {
          rejectHeader.attr = rejectHeader.attr.slice(0, -1) + (i + 1)
        })
      }

      // rejectedAttrsから削除した記録簿と紐づく差し戻しコメント表示用の配列削除
      for (let i = rejectedAttrs.length - 1; i >= 0; i--) {
        if (rejectedAttrs[i].target.includes(index + 1)) {
          rejectedAttrs.splice(i, 1)
        }
      }

      // rejectedAttrsに削除した記録簿よりもindexが高い記録簿に紐づく項目が存在する場合targetの語尾の数値を−１する
      rejectedAttrs.forEach(rejectedAttr => {
        const lastWord = rejectedAttr.target.slice(-1)
        if (index + 2 <= lastWord) {
          rejectedAttr.target =
            rejectedAttr.target.slice(0, -1) + (Number(lastWord) - 1)
        }
      })

      const { removeExpenseFromCurrentPoliticalAction } = useMemoryItemForm()
      removeExpenseFromCurrentPoliticalAction(item)
    }

    return {
      rejectHeaders,
      rejectedAttrs,
      isShowingMemoryItem,
      currentPoliticalAction,
      ...useDialog(),
      calcTotalAmount,
      showMemoryItemForm,
      removeMemoryFormItem,
    }
  },
}
</script>
<style lang="scss"></style>
